import { cn } from '$components'
import { LinkIcon } from '$components'
import { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'

export type SidebarProps = {
  to: string,
  external?: boolean,
  children?: ReactNode,
}

export function SidebarLink({ to, children, external = false }: SidebarProps) {
  return (
    <NavLink
      to={to}
      target={external ? '_blank' : undefined}
      className={({ isActive }) => cn(
        'flex items-center gap-stack-tight p-stack rounded-card-sm text-body-sm text-fg-muted',
        {
          'bg-fg text-fg-inverse': isActive,
          'hover:bg-bg-subtle': !isActive,
        },
      )}
    >
      { children }
      { external && (
        <LinkIcon className="size-3.5" />
      ) }
    </NavLink>
  )
}
